import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueWindowSize from 'vue-window-size'
import nextTick from 'vue';

Vue.config.productionTip = false
Vue.use(VueWindowSize)

new Vue({
  router,
  store,
  vuetify,
  nextTick,
  render: h => h(App)
}).$mount('#app')
